import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScreenDeviceService {
  constructor(private breakpointObserver: BreakpointObserver) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    return this.breakpointObserver.observe([Breakpoints.WebLandscape]);
  }
}
